import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCarga } from '../../services/CargaService';
import {
    gerarNovaVersao,
    alterarDados,
    getHistoricoVersao,
    aplicarJustificativa,
    removerJustificativa,
    setMultiploIgualizado,
} from '../../services/DadoMestreService';
import { gerarStringFiltro, mountFilter, formatArrayData, ColumnConfig, TooltipText } from './PlanejamentoHelper';
import jwt_decode from 'jwt-decode';
import { canEdit } from '../../services/AuthorizationService';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Row,
    Tooltip,
    Label,
    ButtonDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
} from 'reactstrap';

import ModalAntecipado from './Modal/Antecipacao/index';
import ModalSalvarFoto from './ModalSalvarFoto';
import ModalVersao from './ModalVersao';
import ModalEstoqueFinal from './Modal/EstoqueFinal';
import ModalJustificativa from './Modal/Justificativa';
import ModalConfirmation from './Modal/Confirmation';
import ModalConjuntos from './Modal/Conjuntos';

import Select from 'react-select';
import _ from 'lodash';

import { MultiGrid } from 'react-virtualized';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import clsx from 'clsx';
import FileSaver from 'file-saver';

import {
    getResumido,
    getDatas,
    getFiltros,
    getCapacidadesByData,
    atualizaQuantidade as atualizaQuantidadeService,
    atualizaPercEstSeg,
    saveErp,
    getSaveErp,
    saveFabrica,
    setAntecipacoes,
    limparAntecipacoes,
    saveFoto,
    setLoteMinimo,
    setLoteMinimoPorCor,
    setGastar,
    isProcessing,
    isProcessingByOrigin,
    isProcessingByLogin,
    isAnyProcessing,
    saveFabricaEmLote,
    atualizaPercEstSegLote,
    atribuirAlteradoEmLote,
    getNumPv,
    aplicarEstoqueFinalFechamento,
    aplicarConjunto,
    aplicarConjuntoParaBaixo,
} from '../../services/DadoMestreService';

import { getRecursosCriticos } from '../../services/RelatorioService';
import { clearFiles } from '../../services/RelatorioCompletoService';
import { getPlanilhaPlanejamento, getPlanilhaSimulacao } from '../../services/TonyService';

import 'react-virtualized/styles.css'; // only needs to be imported once

import { bindActionCreators } from 'redux'; // redux
import {
    addFilter,
    setCapacidadeOptions,
    setOcupacaoCapacidadeNos,
    setCapacidadeRecursosCriticos,
    setOcupacaoCapacidadeRecursosCriticos,
    showSuccess,
    showError,
    showLoading,
    hideLoading,
    hideProgressLoading,
    showProgressLoading,
    setCurrentDataPV,
    showWarning,
} from '../../actions';
import SelectionTable from '../../utils/SelectionTable';
import Detalhes from './Modal/Detalhes/Index';
import AplicarFabrica from './Modal/AplicarFabrica/Index';
import { socketClient } from '../../socketClient';

import VersionSelector from '../../components/versionSelector';

let tooltipOpen = [];

for (let i = 0; i <= 46; i++) {
    tooltipOpen.push(false);
}

const url = (id) => `/dadomestre/processing/${id}`;

export class Planejamento extends Component {
    constructor(props) {
        super(props);
        this.timeoutExpiresMaterials = null;

        window.addEventListener('mousedown', () => {
            if (this.timeoutExpiresMaterials === null) return;

            clearInterval(this.timeoutExpiresMaterials);
            this.timeoutExpiresMaterials = null;
        });

        socketClient.client.on('update_data', ([newData, tabelas]) => {
            const tabelasVersao = this.getTabelasVersao();
            if (tabelas.dadosResumido !== tabelasVersao.dadosResumido && tabelas.dadosSkuCalculado !== tabelasVersao.dadosSkuCalculado)
                return;
            if (!this.gridRef) return;
            newData.forEach((e) => {
                const indexOf = this.data.findIndex(
                    (x) => x.material === e.material && x.data === e.data && x.estacao === e.estacao && x.colecao === e.colecao
                );

                if (indexOf === -1) return;

                this.data[indexOf] = _.extend(this.data[indexOf], e);
            });
            this.gridRef.forceUpdateGrids();
        });

        socketClient.client.on('materiais_expirados', () => {
            this.timeoutExpiresMaterials = setTimeout(() => {
                socketClient.client.compress(true).emit('desbloquear_materiais_sem_hashes', { client_id: socketClient.client.id });
            }, 2 * 60 * 1000);
        });

        window.addEventListener('beforeunload', () => {
            socketClient.client.compress(true).emit('desbloquear_materiais_sem_hashes', { client_id: socketClient.client.id });
        });

        socketClient.client.on('reconnect', () => {
            // console.log('chegou no reconnect');
        });

        socketClient.client.on('disconnect', () => {
            if (!this.gridRef) return;

            const line = {
                readonly: undefined,
                checked: false,
                client_id: undefined,
                user: undefined,
            };

            this.data = this.data.map((element) => _.extend(element, line));

            this.gridRef.forceUpdateGrids();
        });

        socketClient.client.on('checar_todos', (checked) => {
            if (!this.gridRef || !this.data || !this.data[0]) return;
            if (!canEdit()) return;

            this.data[0].checked = checked;
            this.gridRef.forceUpdateGrids();
        });

        socketClient.client.on('desbloquear_materiais', ({ hashes }) => {
            if (!this.gridRef) return;
            if (!canEdit()) return;

            const line = {
                readonly: undefined,
                checked: false,
                client_id: undefined,
                user: undefined,
            };

            hashes.forEach((hash) => {
                if (!this.hashes.hasOwnProperty(hash)) return;

                const index = this.hashes[hash] + 2;

                if (!this.data[index]) return;

                this.data[index] = _.extend(this.data[index], line);
            });
            this.gridRef.forceUpdateGrids();
        });

        socketClient.client.on('atualiza_materiais_bloqueados', (data) => {
            if (!this.gridRef) return;
            if (!canEdit()) return;

            data.forEach(({ user, client_id, hashes }) => {
                const isMy = client_id === socketClient.client.id;

                if (isMy && !this.data[0].checked) this.data[0].checked = true;

                const line = {
                    readonly: !isMy,
                    checked: isMy,
                    client_id,
                    user,
                };

                hashes.forEach((hash) => {
                    if (!this.hashes.hasOwnProperty(hash)) return;

                    const index = this.hashes[hash] + 2;

                    if (!this.data[index]) return;

                    this.data[index] = _.extend(this.data[index], line);
                });
            });

            this.gridRef.forceUpdateGrids();
        });

        socketClient.client.on('bloquear_materiais', ({ user, client_id, hashes }) => {
            if (!this.gridRef) return;
            if (!canEdit()) return;

            const isMy = client_id === socketClient.client.id;

            if (isMy && !this.data[0].checked) this.data[0].checked = true;

            const line = {
                readonly: !isMy,
                checked: isMy,
                client_id,
                user,
            };

            hashes.forEach((hash) => {
                if (!this.hashes.hasOwnProperty(hash)) return;

                const index = this.hashes[hash] + 2;

                if (!this.data[index]) return;

                this.data[index] = _.extend(this.data[index], line);
            });

            this.gridRef.forceUpdateGrids();
        });
    }

    state = {
        agruparNecessidade: false,
        anchorEl: null,
        menuValor: 0,
        menuNome: '',
        modalData: [],
        dataOptions: [],
        dataInputValue: '',
        large: false,
        overscanRowCount: 0,
        rowHeight: 35,
        materialIsBloqued: false,
        columnCount: ColumnConfig.filter((x) => this.props.colunas.find((c) => c.dataKey === x.dataKey).show).length,
        colunas: ColumnConfig.filter((x) => this.props.colunas.find((c) => c.dataKey === x.dataKey).show),
        overscanColumnCount: 0,
        skuReadonly: false,
        pvSize: { value: 1, label: '1' },
        arrPvSizes: [
            { value: 1, label: '1' },
            { value: 2, label: '2' },
            { value: 3, label: '3' },
            { value: 4, label: '4' },
            { value: 5, label: '5' },
            { value: 6, label: '6' },
            { value: 7, label: '7' },
            { value: 8, label: '8' },
        ],
        allSelected: false,
        openModalAntecipado: false,
        openModalSalvarFoto: false,
        openModalVersao: false,
        openModalEstoqueFinal: false,
        openModalJustificativa: false,
        openModalConjuntos: false,
        openModalConfirmation: false,
        pvsEstoqueFinal: [],
        tooltipOpen: tooltipOpen,
        permanencias: [],
        actionOpen: false,
        actionOpenSalvar: false,
        username: null,
        login: null,
        scrollToRow: 0,
        scrollToColumn: 0,
        itensAntecipar: [],
    };

    selectionTable = new SelectionTable('inicio');
    filtroData = {};
    filtroDataModalDetalhes = {};
    cor = false;
    data = [];
    key = {};
    hashes = {};
    isShowingMessageSaveERP = false;
    aplicadoEmLote = false;

    getTabelasVersao = () =>
        this.props.versaoSelecionada
            ? this.props.versaoSelecionada.nomeTabelas || { dadosResumido: 'dadosResumido', dadosSkuCalculado: 'dadosSkuCalculado' }
            : undefined;

    scroll = (row, col) => {
        this.setState({ scrollToRow: row, scrollToColumn: col });
    };

    orderByKey = (a, b, key) => {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
    };

    orderNos = (a, b) => {
        return this.orderByKey(a, b, 'no');
    };

    orderObservacaoes = (a, b) => {
        return this.orderByKey(a, b, 'observacao');
    };

    updateFiltros = async () => {
        const options = await getFiltros(this.getTabelasVersao());

        options.nos.sort(this.orderNos);
        options.observacoes.sort(this.orderObservacaoes);
        let optionsMaterial = mountFilter(options.materiais);
        let optionsProgramacaoManual = mountFilter(['Manual', 'Automatico']);
        let optionsTipoProdutoAcabado = mountFilter(['P', 'N', 'C']);
        let optionsNo = [...mountFilter(options.nos.map((item) => item.no)), { value: '', label: 'Vazio' }];
        let observacoes = [...mountFilter(options.observacoes.map((item) => item.observacao)), { value: '', label: 'Vazio' }];
        let optionsFabrica = [...mountFilter(options.fabricas.map((item) => item.cdFabrica)), { value: '', label: 'Vazio' }];
        let optionsFabricaVersao = mountFilter(options.fabricasVersao.map((item) => item.cdFabrica));
        let optionsNivelRisco = mountFilter(options.niveisDeRisco);
        let optionsLicenca = mountFilter(options.licenca);
        let optionsCliente = mountFilter(options.cliente);
        let optionsGrupoDeProduto = mountFilter(options.grupoDeProduto);
        let optionsJustificativa = mountFilter(options.justificativas);
        let optionsCTZcos = [...mountFilter(options.ctZcos.map((item) => item)), { value: null, label: 'Vazio' }];
        let optionsFaixaOperacional = [...mountFilter(options.faixaOperacional.map((item) => item)), { value: '', label: 'Vazio' }];

        let optionsFabricaPreparacao = [
            ...mountFilter(options.fabricaPrep.map((item) => item.cdFabricaPrep)),
            { value: '', label: 'Vazio' },
        ];
        let optionsFabricaVersaoPreparacao = mountFilter(options.fabricaVersaoPrep.map((item) => item.cdFabricaPrep));

        let optionsCaracteristica = {};

        options.caracteristicas.forEach((item) => {
            optionsCaracteristica[Planejamento.caracteristicaMapping[item._id]] = item.valores.map((itemValor) => ({
                label: itemValor.dsValCaract,
                value: itemValor.valCaract,
                caracteristicaId: item._id,
            }));
        });

        this.props.addFilter({
            ...optionsCaracteristica,
            optionsMaterial,
            optionsProgramacaoManual,
            optionsTipoProdutoAcabado,
            optionsNo,
            observacoes,
            optionsFabricaPreparacao,
            optionsFabrica,
            optionsFabricaVersao,
            optionsFabricaVersaoPreparacao,
            optionsNivelRisco,
            optionsLicenca,
            optionsCliente,
            optionsGrupoDeProduto,
            optionsJustificativa,
            optionsCTZcos,
            optionsFaixaOperacional,
        });
    };

    getCookie() {
        const userdata = document.cookie.split(';').find((x) => x.trim().startsWith('userdata='));
        if (!userdata) return;

        const cookieString = decodeURIComponent(userdata).replace('userdata=', '');
        if (!cookieString) return;

        const cookie = JSON.parse(cookieString);
        if (!cookie || !cookie.access_token) return;

        const accesToken = jwt_decode(cookie.access_token);
        this.setState({ username: accesToken.name, login: accesToken.login });
    }

    loadScreenData = async () => {
        showLoading();
        const numPv = await getNumPv();
        if (numPv && numPv.length > 0) {
            let arrayPvs = [];
            for (let i = 1; i <= numPv[0].qtdPv; i++) {
                arrayPvs.push({ value: i, label: i });
            }

            this.setState({
                pvSize: { value: 1, label: 1 },
                arrPvSizes: arrayPvs,
            });
        }

        getDatas().then((value) => {
            const dataOptions = formatArrayData(value);

            this.props.setCurrentDataPV(dataOptions[0]);
            this.setState(
                {
                    dataInputValue: dataOptions[0],
                    dataOptions: dataOptions,
                },
                this._getDadosFiltros
            );
        });

        document.addEventListener('copy', (e) => {
            e.preventDefault();
            const { data, selectionTable } = this;
            const value = selectionTable.copy
                .map((columns) =>
                    columns
                        .map((col) => {
                            const column = this.state.colunas[col.y].dataKey;
                            const value = data.slice(2)[col.x][column];

                            if (this.state.colunas[col.y].copy) {
                                return this.state.colunas[col.y].copy(data[col.x]) || '';
                            }

                            return value || '';
                        })
                        .join('\t')
                )
                .join('\n');

            e.clipboardData.setData('text/plain', value);
        });
    };

    validaProcessoSalvarSimulacao = async () => {
        const processing = await isProcessingByOrigin('gravarHistorico');
        if (processing) {
            this.props.showWarning('Existe um processo de salvar simulação em execução. Aguarde!');
            return false;
        }
        return true;
    };

    componentDidMount = async () => {
        this.getCookie();

        const result = await getCarga();
        if (result) {
            if (result.error) return this.props.showError('Falha na carga, contate o Administrador');
            if (result.processing) return this.props.showWarning('Carga em andamento. Aguarde!');
        }

        const processing = await isProcessingByLogin();
        if (processing) {
            this.props.showProgressLoading({
                url: url(processing._id),
                interval: 5000,
                onClose: (_) => {
                    let message = processing.origin + ' finalizado!';
                    this.props.showSuccess(message);
                    this.loadScreenData();
                },
                onFailure: (e) => {
                    this.props.showError('Ocorreu um erro. Aperte F5');
                    this.loadScreenData();
                },
            });
            return;
        }

        this.loadScreenData();
    };

    componentWillUnmount() {
        this.isShowingMessageSaveERP = false;
        socketClient.client.compress(true).emit('desbloquear_materiais_sem_hashes', { client_id: socketClient.client.id });
        this.props.hideProgressLoading();
    }

    componentDidUpdate(prevProps, prevState) {
        const hasFilterChanged = !_.isEqual(prevProps.planejamentoFilter, this.props.planejamentoFilter);
        const hasCapacidadeFilterChanged = !_.isEqual(prevProps.capacidadeFilterSelected, this.props.capacidadeFilterSelected);
        const hasRecursosCriticosFilterChanged = !_.isEqual(
            prevProps.recursosCriticosFilterSelected,
            this.props.recursosCriticosFilterSelected
        );
        const hasSelectCapacidadeOrcadaChanged = !_.isEqual(prevProps.selectCapacidadeOrcada, this.props.selectCapacidadeOrcada);
        if (hasSelectCapacidadeOrcadaChanged || hasFilterChanged || hasCapacidadeFilterChanged || hasRecursosCriticosFilterChanged) {
            this._getDados();
        }
    }

    componentWillUpdate(prevProps) {
        const oldColunas = this.state.colunas;
        const newColunas = ColumnConfig.filter((x) => this.props.colunas.find((c) => c.dataKey === x.dataKey).show);

        const oldChanges = oldColunas.filter((x) => !newColunas.includes(x));
        const newChanges = newColunas.filter((x) => !oldColunas.includes(x));

        if (oldChanges.length > 0 || newChanges.length > 0) {
            this.setState(
                {
                    columnCount: newColunas.length,
                    colunas: newColunas,
                },
                () => this.gridRef.recomputeGridSize()
            );
        }
    }

    render() {
        const inputValue = '';
        const data = this.data;

        const { columnCount, overscanColumnCount, overscanRowCount, rowHeight, pvSize, arrPvSizes } = this.state;
        const hasOneChecked = this.data.slice(2).some((x) => x.checked);
        const hasJustificativa = this.data.slice(2).some((x) => x.justificativaNP && x.checked);

        return (
            <div className='animated fadeIn h-100'>
                <Card className='h-100 mb-0'>
                    <CardHeader className='p-2'>
                        <Row className='align-items-start p-0' style={{ height: '38px' }}>
                            <Col md='auto pr-0'>
                                {canEdit() && (
                                    <ButtonDropdown
                                        className='mr-1'
                                        isOpen={this.state.actionOpenSalvar}
                                        toggle={() => {
                                            this.setState({ actionOpenSalvar: !this.state.actionOpenSalvar });
                                        }}
                                    >
                                        <DropdownToggle caret color='primary'>
                                            <i className='fa fa-save'></i> Salvar
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem onClick={(_) => this._salvarErp(this.state.login)}>
                                                <i className='fa fa-truck'></i> ERP por Usuário
                                            </DropdownItem>
                                            <DropdownItem onClick={(_) => this._salvarErp()}>
                                                <i className='fa fa-truck'></i> ERP Todos
                                            </DropdownItem>
                                            <DropdownItem onClick={this._toggleModalSalvarFoto}>
                                                <i className='fa fa-camera'></i> Simulação
                                            </DropdownItem>
                                            <DropdownItem onClick={this._generateSimulacao}>
                                                <i className='fa fa-cloud-download'></i> Gerar Excel Simulação
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </ButtonDropdown>
                                )}
                            </Col>
                            <Col md='auto'>
                                <ButtonDropdown
                                    className='mr-1'
                                    isOpen={this.state.actionOpen}
                                    toggle={(_) => this.setState({ actionOpen: !this.state.actionOpen })}
                                >
                                    <DropdownToggle caret color='primary'>
                                        <i className='fa fa-bolt'></i> Ações
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={async (_) => {
                                                    if ((await this.validaProcessoSalvarSimulacao()) === false) return;
                                                    this.setState({ modalFabricasIsOpen: true });
                                                }}
                                            >
                                                <i className='fa fa-wrench'></i> Aplicar Fábricas
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={() =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._atualizaLoteMinimo();
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-magic'></i> Aplicar lote
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={(e) =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._atualizaLoteMinimoPorCor(e, false);
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-magic'></i> Aplicar lote por cor
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={(e) =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._aplicarMultiploIgualizado(e);
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-magic'></i> Aplicar múltiplo igualizado
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={(e) =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._atualizaLoteMinimoPorCor(e, true);
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-magic'></i> Limpar lote por cor
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem onClick={this._onOpenModalJustificativa}>
                                                <i className='fa fa-magic'></i> Adicionar Justificativa
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem onClick={this._onOpenModalConjuntos}>
                                                <i className='fa fa-magic'></i> Conjuntos
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem onClick={this._atribuirAlterado}>
                                                <i className='fa fa-magic'></i> Marcar P/ Alterado
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem onClick={this._onOpenModalAntecipado}>
                                                <i className='fa fa-hand-o-left'></i> Antecipar
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem onClick={this._onOpenModalAgruparNecessidade}>
                                                <i className='fa fa-hand-o-left'></i> Agrupar necessidade
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={() =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._toggleLimparAntecipacao();
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-eraser'></i> Limpar Antecipação
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={() =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._toggleLimparEstSeguranca();
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-eraser'></i> Limpar Est. Seguranca
                                            </DropdownItem>
                                        )}
                                        {hasJustificativa && (
                                            <DropdownItem
                                                onClick={() =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._handleRemoveJustificativa();
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-eraser'></i> Limpar Justificativa
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem onClick={this._onOpenModalEstoqueFinal}>
                                                <i className='fa fa-eraser'></i> Aplicar estoque final BI
                                            </DropdownItem>
                                        )}
                                        {hasOneChecked && (
                                            <DropdownItem
                                                onClick={() =>
                                                    this._onOpenModalConfirmation(() => {
                                                        this._atualizaGastar();
                                                        this._onCloseModalConfirmation();
                                                    })
                                                }
                                            >
                                                <i className='fa fa-magic'></i> Aplicar gastar
                                            </DropdownItem>
                                        )}
                                        <DropdownItem onClick={(e) => this._getPlanilha()}>
                                            <i className='fa fa-cloud-download'></i> Gerar CSV
                                        </DropdownItem>
                                        <DropdownItem onClick={(e) => this._criarNovaVersao()}>
                                            <i className='fa fa-code-fork'></i> Criar nova versão
                                        </DropdownItem>
                                    </DropdownMenu>
                                </ButtonDropdown>

                                {/* <Button type='submit' size='md' color='primary' onClick={this._atualizaLoteMinimo}>

                                </Button> */}
                            </Col>

                            <Col md='auto mt-2 pl-0'>
                                <Label htmlFor='dataPeriodo'>Períodos:</Label>
                            </Col>

                            <Col xs='12' sm='6' lg='4' xl='2' className='pl-0 mb-2'>
                                <Select
                                    id='dataPeriodo'
                                    onChange={this._onDataInputChange}
                                    isClearable
                                    isSearchable
                                    inputValue={inputValue}
                                    value={this.state.dataInputValue}
                                    name='dataPeriodo'
                                    options={this.state.dataOptions}
                                    placeholder='Data Período'
                                />
                            </Col>

                            <Col md='auto mt-2 pl-0'>
                                <Label htmlFor='versionSelector'>Versões:</Label>
                            </Col>

                            <Col xs='12' sm='6' lg='4' xl='2' className='pl-0 mb-2'>
                                <VersionSelector
                                    onChange={(versao) => {
                                        this._getDados(undefined, true, versao);
                                    }}
                                />
                            </Col>

                            <Col md='auto mt-2 pl-0'>
                                <Label htmlFor='pvSize'>Qtd. PVs:</Label>
                            </Col>

                            <Col xs='12' sm='3' lg='2' xl='2' className='pl-0 mb-2'>
                                <Select
                                    id='pvSize'
                                    onChange={this._onPvSizeChange}
                                    isClearable
                                    value={pvSize}
                                    name='dataPeriodo'
                                    options={arrPvSizes}
                                    placeholder='Data Período'
                                />
                            </Col>
                            <Col>
                                {this.state.large && (
                                    <Detalhes
                                        onClose={this._toggleLarge}
                                        readonly={this.state.skuReadonly}
                                        filter={this.filtroDataModalDetalhes}
                                    />
                                )}
                            </Col>
                            <Col>
                                <AplicarFabrica
                                    items={this.data.slice(2).filter((x) => x.checked)}
                                    isOpen={this.state.modalFabricasIsOpen}
                                    onClose={this._onCloseAplicarFabrica}
                                    update={this._updateAplicarFabrica}
                                />
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className='p-0'>
                        <AutoSizer>
                            {({ width, height }) => {
                                return (
                                    <MultiGrid
                                        style={{
                                            WebkitTouchCallout: 'none',
                                            WebkitUserSelect: 'none',
                                            KhtmlUserSelect: 'none',
                                            MozUserSelect: 'none',
                                            msUserSelect: 'none',
                                            userSelect: 'none',
                                        }}
                                        fixedRowCount={2}
                                        ref={(r) => (this.gridRef = r)}
                                        cellRenderer={this._renderBodyCell}
                                        className={'BodyGrid'}
                                        data-scroll={'scrollable'}
                                        columnWidth={this._getColumnWidth}
                                        columnCount={columnCount}
                                        height={height}
                                        noContentRenderer={this._noContentRenderer}
                                        overscanColumnCount={overscanColumnCount}
                                        overscanRowCount={overscanRowCount}
                                        rowHeight={rowHeight}
                                        rowCount={data.length}
                                        width={width}
                                        scrollToRow={this.state.scrollToRow}
                                        scrollToColumn={this.state.scrollToColumn}
                                    />
                                );
                            }}
                        </AutoSizer>
                    </CardBody>
                </Card>
                <Menu anchorEl={this.state.anchorEl} keepMounted open={Boolean(this.state.anchorEl)} onClose={this.handleCloseMenu}>
                    <MenuItem onClick={this.handleAplicarParaTodos}>Aplicar {this.state.menuValor} para todos materiais</MenuItem>
                </Menu>
                <ModalEstoqueFinal
                    isOpen={this.state.openModalEstoqueFinal}
                    onClose={this._onCloseModalEstoqueFinal}
                    items={this.state.pvsEstoqueFinal}
                    onSave={this._handleSaveEstoqueFinal}
                />
                <ModalJustificativa
                    isOpen={this.state.openModalJustificativa}
                    onClose={this._onCloseModalJustificativa}
                    items={this.state.itensAntecipar}
                    onSave={this._handleSaveJustificativa}
                />
                <ModalConjuntos
                    isOpen={this.state.openModalConjuntos}
                    onClose={this._onCloseModalConjuntos}
                    items={this.state.itensAntecipar}
                    onSave={this._handleSaveConjuntos}
                />
                <ModalVersao
                    isOpen={this.state.openModalVersao}
                    onClose={this._onCloseModalVersao}
                    onCriarVersao={this._handleCriarVersao}
                />
                <ModalAntecipado
                    items={this.state.itensAntecipar}
                    isOpen={this.state.openModalAntecipado}
                    agruparNecessidade={this.state.agruparNecessidade}
                    onClose={this._onCloseModalAntecipado}
                    onSave={this._handleSaveAntecipacao}
                />
                <ModalConfirmation
                    isOpen={this.state.openModalConfirmation}
                    onClose={this._onCloseModalConfirmation}
                    onSave={this.state.modalConfirmationMethod}
                />

                {this.state.openModalSalvarFoto && (
                    <ModalSalvarFoto
                        toggle={this._toggleModalSalvarFoto}
                        handleSave={this._toggleSaveFoto}
                        showLoading={this.props.showLoading}
                        hideLoading={this.props.hideLoading}
                    />
                )}
            </div>
        );
    }

    _filterMaterialParaAntecipar = (e) =>
        e.checked && e.material && !((e.conjunto && e.conjunto === 'N') || (e.conjuntoFilhoTipo && e.conjuntoFilhoTipo === 'V'));

    _handleSaveAntecipacao = (itemsAlterados) => {
        const isPercEstoqueSeg = itemsAlterados[0].atualizar === 'percEstoqueSeg';
        const items = itemsAlterados.map(
            (line) => this._constroiObjeto(line)[!this.state.agruparNecessidade ? line.atualizar : 'qtdProgramada']
        );
        var msgAppear = false;
        const apenasPorMaterial = itemsAlterados.every((e) => e.apenasPorMaterial?.length);

        if (!this.state.agruparNecessidade) {
            if (isPercEstoqueSeg) {
                atualizaPercEstSegLote({ materiais: items, tabelas: this.getTabelasVersao(), apenasPorMaterial }).then((id) => {
                    this.props.showProgressLoading({
                        url: url(id),
                        interval: 5000,
                        onClose: (_) => {
                            if (!msgAppear) this.props.showSuccess('Estoque de segurança alterado!');

                            this.setState({ openModalAntecipado: false }, () => {
                                msgAppear = true;
                                this._getDados(items);
                            });
                        },
                        onFailure: (e) => {
                            msgAppear = true;
                            this.props.showError(e);
                        },
                    });
                });
            } else {
                items.tabelas = this.getTabelasVersao();
                setAntecipacoes({ materiais: items, tabelas: this.getTabelasVersao(), apenasPorMaterial }).then((id) => {
                    this.props.showProgressLoading({
                        url: url(id),
                        interval: 2000,
                        onClose: (_) => {
                            if (!msgAppear) this.props.showSuccess('Antecipação concluída!');

                            this.setState({ openModalAntecipado: false }, () => {
                                msgAppear = true;
                                this._getDados(items);
                            });
                        },
                        onFailure: (e) => {
                            msgAppear = true;
                            this.props.showError(e);
                        },
                    });
                });
            }
        } else {
            items.tabelas = this.getTabelasVersao();
            setAntecipacoes({
                materiais: items,
                tabelas: this.getTabelasVersao(),
                agruparNecessidade: this.state.agruparNecessidade,
                apenasPorMaterial,
            }).then((id) => {
                this.props.showProgressLoading({
                    url: url(id),
                    interval: 5000,
                    onClose: (_) => {
                        if (!msgAppear) this.props.showSuccess('Antecipação concluída!');

                        this.setState({ openModalAntecipado: false }, () => {
                            msgAppear = true;
                            this._getDados(items);
                        });
                    },
                    onFailure: (e) => {
                        msgAppear = true;
                        this.props.showError(e);
                    },
                });
            });
        }
    };

    _onCloseAplicarFabrica = () => this.setState({ modalFabricasIsOpen: false });

    _equalizaFabricaLote = (data) => {
        return data.map((tmpData) => {
            return this.data
                .filter((material) => {
                    return tmpData.material === material.material && tmpData.pv === material.pv ? true : false;
                })
                .map((item) => {
                    const listaTecnica = item.listaTecnica.find((lt) => lt.CD_FABRICA === tmpData.fabrica);

                    item.cdFabrica = tmpData.fabrica;
                    item.no = listaTecnica.no;
                    item.cdFabricaPrep = listaTecnica.cdFabricaPrep;
                    item.tempo = listaTecnica.tempo;
                    item.tempoPreparacao = listaTecnica.tempoPreparacao;

                    return {
                        material: item.material,
                        estacao: item.estacao,
                        colecao: item.colecao,
                        data: item.data,
                        fabrica: item.cdFabrica,
                        fabricaPrep: item.cdFabricaPrep,
                        no: item.no,
                        tempo: item.tempo,
                        tempoPreparacao: item.tempoPreparacao,
                        pv: item.pv,
                    };
                });
        });
    };

    _updateAplicarFabrica = (materiais, paramsArray, fabrica) => {
        saveFabricaEmLote({ materiais, tabelas: this.getTabelasVersao() }).then((id) =>
            this.props.showProgressLoading({
                url: url(id),
                interval: 5000,
                onClose: (_) => {
                    this.props.showSuccess('Fábricas aplicadas!');
                    this._onCloseAplicarFabrica();
                    this.updateFiltros();
                    this._getDados(paramsArray);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            })
        );
    };

    lineToId = ({ material, colecao, estacao, data }) => ({
        m: material,
        d: data,
        e: estacao,
        c: colecao,
    });

    _atribuirAlterado = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        const data = this.data
            .slice(2)
            .filter((line) => line.checked)
            .map(this.lineToId);
        await atribuirAlteradoEmLote({ ids: data, tabelas: this.getTabelasVersao() });
        this.props.hideLoading();
        this.props.showSuccess(`Atribuição para alterado realizado com sucesso em ${data.length} materiais`);
    };

    _toggleLimparAntecipacao = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        this.data[0].checked = false;
        let checkedItens = this.data.filter((x) => x.checked && x.material);
        let paramsArray = [];
        for (let i = 0; i < checkedItens.length; i++) {
            let e = checkedItens[i];
            if (e.qtdProgramada > 0 || e.percAnt > 0 || e.percAntVendaFutura > 0)
                paramsArray.push({
                    material: e.material,
                    data: e.data,
                    estacao: e.estacao,
                    colecao: e.colecao,
                    percentual: 0,
                    cor: e.cor,
                });

            e.checked = false;
        }

        if (paramsArray.length === 0) {
            this.gridRef.forceUpdateGrids();
            this.props.showSuccess('Nenhuma antecipação para limpar!');
            this.props.hideLoading();
            return;
        }
        this.props.hideLoading();
        limparAntecipacoes(paramsArray, undefined, this.getTabelasVersao()).then((id) =>
            this.props.showProgressLoading({
                url: url(id),
                interval: 5000,
                onClose: (_) => {
                    this.props.showSuccess('Antecipação limpa!');
                    this._getDados(paramsArray);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            })
        );
    };

    _toggleLimparEstSeguranca = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        this.data[0].checked = false;
        let checkedItens = this.data.filter((x) => x.checked && x.material);
        let paramsArray = [];
        for (let i = 0; i < checkedItens.length; i++) {
            let e = checkedItens[i];
            paramsArray.push({
                material: e.material,
                data: e.data,
                estacao: e.estacao,
                colecao: e.colecao,
                percentual: 0,
                cor: e.cor,
            });

            e.checked = false;
        }

        atualizaPercEstSegLote({ materiais: paramsArray, tabelas: this.getTabelasVersao() }).then((id) => {
            this.props.hideLoading();
            this.props.showProgressLoading({
                url: url(id),
                interval: 5000,
                onClose: (_) => {
                    this.props.showSuccess('Estoque de segurança limpo!');
                    this._getDados(paramsArray);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            });
        });
    };

    _toggleSaveFoto = async (nomeFoto, tipo, oficial) => {
        const processo = await isAnyProcessing();
        if (processo) {
            this.props.showWarning('Processo de ' + processo.origin + ' em execução. Aguarde!');
            return;
        }
        saveFoto({
            data: this.state.dataOptions[0].value.data,
            anoPer: this.state.dataOptions[0].value.anoPer,
            numPer: this.state.dataOptions[0].value.numPer,
            nomeFoto: nomeFoto,
            tipo: tipo,
            oficial: oficial,
            tabelas: this.getTabelasVersao(),
        }).then((id) => {
            this.props.showProgressLoading({
                url: url(id),
                interval: 5000,
                onClose: (_) => {
                    this.setState({ openModalSalvarFoto: !this.state.openModalSalvarFoto });
                    this.props.hideLoading();
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            });
        });
    };

    _hasFilterActive = () => {
        const filtros = this.props.planejamentoFilter;
        return Object.keys(filtros).some((filter) => {
            const value = filtros[filter];
            if (Array.isArray(value) && value.length > 0) return true;
            if (value && typeof value === 'object' && Object.keys(value).length > 0) return true;
            if (value && typeof value === 'string' && value.trim() !== '') return true;
            return false;
        });
    };

    _generateSimulacao = async () => {
        this.props.showLoading();

        const processo = await isAnyProcessing();
        if (processo) {
            this.props.showWarning('Processo de ' + processo.origin + ' em execução. Aguarde!');
            this.props.hideLoading();
            return;
        }

        const materiaisFiltrados = this.data
            .slice(2)
            .filter(
                (item, index, self) =>
                    index ===
                    self.findIndex((t) => t.material === item.material && t.estacao === item.estacao && t.colecao === item.colecao)
            )
            .map((x) => ({ material: x.material, estacao: x.estacao, colecao: x.colecao }));

        const firstPvIndex = this.state.dataOptions.findIndex((x) => x === this.state.dataInputValue);
        const pvsFiltradas = this.state.dataOptions.slice(firstPvIndex, firstPvIndex + this.state.pvSize.value);

        const datas = pvsFiltradas.map((el) => el.value.data);

        await clearFiles();
        await getPlanilhaSimulacao(
            {
                datas,
                tipo: 'S',
                tabelas: this.getTabelasVersao(),
            },
            {
                materiais: this._hasFilterActive() ? materiaisFiltrados : [],
            }
        )
            .then((id) => {
                const interval = setInterval(async () => {
                    isProcessing(id)
                        .then(async (result) => {
                            this.props.showProgressLoading({
                                url: `/dadomestre/processing/${id}`,
                                onClose: () => {},
                                interval: 2000,
                            });
                            if (result.error) {
                                this.props.hideLoading();
                                this.props.showError(result.error.err);
                                clearInterval(interval);
                            } else if (!result.processing) {
                                const url = `/tony/files/${id}.zip`;
                                this.download(url, `${id}.zip`);
                                this.props.hideLoading();
                                clearInterval(interval);
                            }
                        })
                        .catch((e) => {});
                }, 2500);
            })
            .catch(console.error);
    };

    download = async (url, filename) => {
        await fetch(url, {
            mode: 'no-cors',
        })
            .then((transfer) => {
                return transfer.blob();
            })
            .then((bytes) => {
                let elm = document.createElement('a');
                elm.href = URL.createObjectURL(bytes);
                //elm.type = 'application/zip';
                elm.setAttribute('download', filename);
                elm.click();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    _refresh = () => {
        this._getDados();
    };

    _onCloseModalAntecipado = () => this.setState({ openModalAntecipado: false }, this.props.hideLoading);
    _onCloseModalEstoqueFinal = () => this.setState({ openModalEstoqueFinal: false }, this.props.hideLoading);
    _onCloseModalJustificativa = () => this.setState({ openModalJustificativa: false }, this.props.hideLoading);
    _onCloseModalConjuntos = () => this.setState({ openModalConjuntos: false });
    _onCloseModalConfirmation = () => this.setState({ openModalConfirmation: false }, this.props.hideLoading);

    _onOpenModalConfirmation = async (method = null) => {
        this.setState({
            openModalConfirmation: true,
            modalConfirmationMethod: method,
        });
    };
    _onOpenModalAntecipado = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        this.setState({
            agruparNecessidade: false,
            openModalAntecipado: true,
            itensAntecipar: this.data.slice(2).filter(this._filterMaterialParaAntecipar),
        });
    };

    _onOpenModalJustificativa = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        this.setState(
            {
                agruparNecessidade: false,
                openModalJustificativa: true,
                itensAntecipar: this.data.slice(2).filter(this._filterMaterialParaAntecipar),
            },
            this.props.hideLoading
        );
    };

    _onOpenModalConjuntos = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        this.setState(
            {
                agruparNecessidade: false,
                openModalConjuntos: true,
                itensAntecipar: this.data.slice(2).filter(this._filterMaterialParaAntecipar),
            },
            this.props.hideLoading
        );
    };

    _onOpenModalEstoqueFinal = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        let pvVersao = [];
        const items = this.data.slice(2).filter(this._filterMaterialParaAntecipar);
        if (items && Array.isArray(items)) {
            const pvs = items
                .filter((x) => x.periodo)
                .map((x) => ({ numPer: x.periodo.NUM_PER, anoPer: x.periodo.ANO_PER }))
                .filter((v, i, s) => s.findIndex((x) => x.numPer === v.numPer && x.anoPer === v.anoPer) === i);
            for (let i = 0; i < pvs.length; i++) {
                const item = pvs[i];
                pvVersao.push({
                    numPer: item.numPer,
                    anoPer: item.anoPer,
                    versoes: await getHistoricoVersao({ numPer: item.numPer, anoPer: item.anoPer }),
                });
            }
        }

        this.setState({ openModalEstoqueFinal: true, pvsEstoqueFinal: pvVersao }, this.props.hideLoading);
    };

    _onOpenModalAgruparNecessidade = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.props.showLoading();
        this.setState({
            agruparNecessidade: true,
            openModalAntecipado: true,
            itensAntecipar: this.data.slice(2).filter(this._filterMaterialParaAntecipar),
        });
        this.props.hideLoading();
    };

    _toggleModalSalvarFoto = () => {
        this.setState({ openModalSalvarFoto: !this.state.openModalSalvarFoto });
    };

    _addMaterialSelected = (arr, item) => {
        const findItem = arr.find((e) => e.data === item.data);

        if (findItem) findItem.materiais.push(item.material);
        else
            arr.push({
                data: item.data,
                materiais: [item.material],
            });
    };

    _atualizaQuantidade = (data) => {
        this.props.showLoading();
        let paramsArray = [
            {
                material: data.material,
                estacao: data.estacao,
                colecao: data.colecao,
                cor: data.cor,
            },
        ];
        if (data.conjuntoComp) {
            data.conjuntoComp.forEach((e) => {
                let dados = this.data.filter((x) => x.material === e.material && x.estacao === data.estacao && x.colecao === data.colecao);
                paramsArray = paramsArray.concat(
                    dados.map((x) => ({ material: e.material, estacao: data.estacao, colecao: data.colecao, cor: x.cor }))
                );
            });
        }
        data.tabelas = this.getTabelasVersao();
        atualizaQuantidadeService(data).then((value) => {
            value.data.forEach((e) => {
                let param = paramsArray.find((x) => x.material === e.material && x.estacao === e.estacao && x.colecao === e.colecao);
                if (param) {
                    e.cor = param.cor;
                }
                let linha = this.data.find(
                    (x) => x.material === e.material && x.data === e.data && x.estacao === e.estacao && x.colecao === e.colecao
                );
                if (linha) {
                    linha = _.extend(linha, e);
                    linha.totalMinutos = linha.qtdProgramada * linha.tempo;
                }
            });
            this.gridRef.forceUpdateGrids();
            this.props.hideLoading();
        });
    };

    _atualizaFabrica = (data) => {
        let paramsArray = [
            {
                material: data.material,
                estacao: data.estacao,
                colecao: data.colecao,
                cor: data.cor,
            },
        ];
        let listaTecnica = data.listaTecnica.find((x) => x.CD_FABRICA === data.cdFabrica);
        if (listaTecnica) {
            data.no = listaTecnica.no;
            data.cdFabricaPrep = listaTecnica.cdFabricaPrep;
            data.tempo = listaTecnica.tempo;
            data.tempoPreparacao = listaTecnica.tempoPreparacao;
        }
        showLoading();
        const materials = this._equalizaFabricas(data);

        materials.map((material) => {
            saveFabrica({
                materiais: [
                    {
                        material: material.material,
                        estacao: material.estacao,
                        colecao: material.colecao,
                        data: material.data,
                        fabrica: data.cdFabrica,
                        fabricaPrep: material.cdFabricaPrep,
                        no: material.no,
                        tempo: material.tempo,
                        tempoPreparacao: material.tempoPreparacao,
                    },
                ],
                tabelas: this.getTabelasVersao(),
            }).then((value) => {
                this._getDados(paramsArray);
                this.updateFiltros();
            });
            return undefined;
        });
    };

    _equalizaFabricas = (data) => {
        return this.data.filter((material) => {
            return data.material === material.material && data.pv === material.pv ? true : false;
        });
    };

    _atualizaPercEstSeg = (data) => {
        this.props.showLoading();
        let paramsArray = [
            {
                material: data.material,
                estacao: data.estacao,
                colecao: data.colecao,
                cor: data.cor,
            },
        ];
        data.tabelas = this.getTabelasVersao();
        atualizaPercEstSeg(data).then((value) => {
            this._getDados(paramsArray);
        });
    };

    _onDataInputChange = (inputValue, { action }) => {
        this.props.setCurrentDataPV(inputValue);
        this.setState({ dataInputValue: inputValue }, this._getDados);
    };

    _onPvSizeChange = (inputPvSize) => {
        this.setState({ pvSize: inputPvSize }, this._getDados);
    };

    _showProgressLoadingSaveErp = async (novo = false) => {
        let processingByOrigin = await isProcessingByOrigin('saveErpFull');
        if (!processingByOrigin) processingByOrigin = await isProcessingByLogin('saveErp');

        let idProcessing;
        if (processingByOrigin && processingByOrigin.processing) {
            idProcessing = processingByOrigin._id;
            if (!novo) this.props.showError('Existe outro processo de salvar em execução! Tente novamente mais tarde.');

            this.props.showProgressLoading({
                url: url(idProcessing),
                interval: 5000,
                onClose: async (_) => {
                    try {
                        const resultGetSaveErp = await getSaveErp();
                        if (resultGetSaveErp && resultGetSaveErp.length === 0) {
                            if (this.isShowingMessageSaveERP) return;
                            this.isShowingMessageSaveERP = true;
                            this.props.showSuccess('ERP salvo com Sucesso');
                        } else this.props.showError('Houve um erro!');
                    } catch (_) {
                        return this._showErro();
                    }
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            });
        }
    };

    _salvarErp = async (login) => {
        this.props.showLoading();
        try {
            this.isShowingMessageSaveERP = false;
            let processingByOrigin = await isProcessingByOrigin('saveErpFull');
            if (!processingByOrigin && !login) processingByOrigin = await isProcessingByOrigin('saveErp');
            if (!processingByOrigin) processingByOrigin = await isProcessingByLogin('saveErp');
            if (processingByOrigin && processingByOrigin.processing) {
                this.props.showError('Existe outro processo de salvar em execução! Tente novamente mais tarde.');
            } else {
                let result = await saveErp(login, this.getTabelasVersao());
                if (result.data) this._showProgressLoadingSaveErp(true);
                else this.props.showError('Existe outro processo de salvar em execução! Tente novamente mais tarde.');
            }
        } catch (_) {
            return this._showErro();
        }
        this.props.hideLoading();
    };

    _showErro = () => {
        this.props.showError('Houve um erro!');
    };

    _atualizaLoteMinimo = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.data[0].checked = false;
        let checkedItens = this.data.filter((x) => x.checked && x.material);
        let paramsArray = [];
        for (let i = 0; i < checkedItens.length; i++) {
            let e = checkedItens[i];
            paramsArray.push({
                material: e.material,
                data: e.data,
                estacao: e.estacao,
                colecao: e.colecao,
                quantidade: e.loteMinimo,
                cor: e.cor,
            });

            e.checked = false;
        }

        if (paramsArray.length === 0) return;

        setLoteMinimo({ materiais: paramsArray, tabelas: this.getTabelasVersao() }).then((id) =>
            this.props.showProgressLoading({
                url: url(id),
                interval: 5000,
                onClose: (_) => {
                    this.props.showSuccess('Lote aplicado!');
                    this._getDados(paramsArray);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            })
        );
    };
    _atualizaLoteMinimoPorCor = async (e, clear) => {
        e.preventDefault();
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.data[0].checked = false;
        let checkedItens = this.data.filter((x) => x.checked && x.material);
        let paramsArray = [];
        for (let i = 0; i < checkedItens.length; i++) {
            let e = checkedItens[i];
            paramsArray.push({
                material: e.material,
                data: e.data,
                estacao: e.estacao,
                colecao: e.colecao,
                quantidade: e.loteMinimo,
                cor: e.cor,
            });

            e.checked = false;
        }

        if (paramsArray.length === 0) return;

        setLoteMinimoPorCor({ clear, materiais: paramsArray, tabelas: this.getTabelasVersao() }).then((id) =>
            this.props.showProgressLoading({
                url: url(id),
                interval: 5000,
                onClose: (_) => {
                    this.props.showSuccess('Lote aplicado!');
                    this._getDados(paramsArray);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            })
        );
    };
    _aplicarMultiploIgualizado = async (e) => {
        e.preventDefault();
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.data[0].checked = false;
        let checkedItens = this.data.filter((x) => x.checked && x.material);
        let paramsArray = [];
        for (let i = 0; i < checkedItens.length; i++) {
            let e = checkedItens[i];
            paramsArray.push({
                material: e.material,
                data: e.data,
                estacao: e.estacao,
                colecao: e.colecao,
            });

            e.checked = false;
        }
        const materiais = [...new Set(checkedItens.map((x) => x.material))];
        const pvs = [...new Set(checkedItens.map((x) => x.pv))];

        if (paramsArray.length === 0) return;

        setMultiploIgualizado({ materiais, pvs, tabelas: this.getTabelasVersao() }).then((id) =>
            this.props.showProgressLoading({
                url: url(id),
                interval: 2000,
                onClose: (_) => {
                    this.props.showSuccess('Múltiplo igualizado aplicado!');
                    this._getDados(paramsArray);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            })
        );
    };

    _atualizaGastar = async () => {
        this.data[0].checked = false;
        let checkedItens = this.data.filter((x) => x.checked && x.material);
        let paramsArray = [];
        for (let i = 0; i < checkedItens.length; i++) {
            let e = checkedItens[i];
            paramsArray.push({
                material: e.material,
                data: e.data,
                estacao: e.estacao,
                colecao: e.colecao,
                cor: e.cor,
                gastar: true,
            });

            e.checked = false;
        }

        if (paramsArray.length === 0) return;

        setGastar({ materiais: paramsArray, tabelas: this.getTabelasVersao() }).then((id) =>
            this.props.showProgressLoading({
                url: url(id),
                interval: 5000,
                onClose: (_) => {
                    this.props.showSuccess('Gastar aplicado!');
                    this._getDados(paramsArray);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            })
        );
    };

    _getPlanilha = () => {
        this.props.showLoading();
        if (!this.state.dataInputValue) {
            this.props.hideLoading();
            return (this.data = []);
        }

        let dataLength = this.state.dataOptions.length;
        let dataIndex = this.state.dataOptions.findIndex((x) => x.value.data === this.state.dataInputValue.value.data);
        let dataAnt = this.state.dataOptions[dataIndex === 0 ? 0 : dataIndex - 1].value.data;
        const pv = this.state.pvSize.value - 1;
        dataIndex = dataIndex + pv >= dataLength ? dataLength - 1 : dataIndex + pv;

        let dataFim = this.state.dataOptions[dataIndex].value.data;

        this.filtroData = {
            dataAnt: dataAnt,
            dataAtu: this.state.dataInputValue.value.data,
            dataFim: dataFim,
        };

        let filtros = gerarStringFiltro(this.props);
        if (filtros) this.filtroData.filtros = filtros;

        const data = this.filtroData;

        function s2ab(s) {
            var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            var view = new Uint8Array(buf); //create uint8array as viewer
            for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
            return buf;
        }

        getPlanilhaPlanejamento({ data, tabelas: this.getTabelasVersao() }).then((res) => {
            this.props.hideLoading();
            FileSaver.saveAs(new Blob([s2ab(res)], { type: 'application/octet-stream' }), 'Planejamento.xlsx');
        });
    };

    _getDados = async (paramsArray, showLoading = true, versao) => {
        if (showLoading) this.props.showLoading();
        //socketClient.client.compress(true).emit('desbloquear_materiais_sem_hashes', { client_id: socketClient.client.id });

        if (!this.state.dataInputValue) {
            this.props.hideLoading();
            return (this.data = []);
        }

        let dataLength = this.state.dataOptions.length;
        let dataIndex = this.state.dataOptions.findIndex((x) => x.value.data === this.state.dataInputValue.value.data);
        let dataAnt = this.state.dataOptions[dataIndex === 0 ? 0 : dataIndex - 1].value.data;
        const pv = this.state.pvSize.value - 1;
        dataIndex = dataIndex + pv >= dataLength ? dataLength - 1 : dataIndex + pv;

        let dataFim = this.state.dataOptions[dataIndex].value.data;

        this.filtroData = {
            dataAnt: dataAnt,
            dataAtu: this.state.dataInputValue.value.data,
            dataFim: dataFim,
        };

        let filtros = gerarStringFiltro(this.props);
        if (filtros) this.filtroData.filtros = filtros;

        if (paramsArray) {
            this.filtroData.filtros = JSON.stringify({ material: paramsArray.map((x) => x.material) });
        }

        const data = this.filtroData;

        if (!paramsArray) {
            this.data = [];
        }

        getCapacidadesByData(this.state.dataInputValue.value.data)
            .then((value) => {
                this.props.setCapacidadeOptions(this.props.selectCapacidadeOrcada ? value.capacidadeOrcada : value.capacidade);
            })
            .catch((e) => {
                console.error(e);
            });

        getRecursosCriticos(this.getTabelasVersao().dadosResumido, this.state.dataInputValue.value.data)
            .then((value) => {
                this.props.setCapacidadeRecursosCriticos(value.capacidadeRecursosCriticos);
                this.props.setOcupacaoCapacidadeRecursosCriticos(value.ocupacaoRecursosCriticos);
            })
            .catch((e) => {
                console.error(e);
            });

        try {
            data.tabelas = versao ? versao.nomeTabelas : this.getTabelasVersao();
            let value = await getResumido(data);
            if (value) {
                if (paramsArray) {
                    value.dados.forEach((e) => {
                        let param = paramsArray.find(
                            (x) => x.material === e.material && x.estacao === e.estacao && x.colecao === e.colecao
                        );
                        if (param) {
                            e.cor = param.cor;
                        }
                        let linha = this.data.find(
                            (x) => x.material === e.material && x.data === e.data && x.estacao === e.estacao && x.colecao === e.colecao
                        );
                        if (linha) linha = _.extend(linha, e);
                    });
                    const tabelas = this.getTabelasVersao();
                    socketClient.client.compress(true).emit('update_data', [value.dados, tabelas]);
                } else {
                    this.keys = value.dados.reduce((a, b) => {
                        const key = b.material + b.colecao + b.estacao;
                        if (!a.hasOwnProperty(key)) a[key] = b.pv;
                        return a;
                    }, {});
                    this.data = this.data.concat([{ checked: false, type: 1 }], [{ type: 3 }], value.dados);
                    this.hashes = value.hashes;
                    socketClient.client.compress(true).emit('atualiza_materiais_bloqueados');
                }

                if (filtros === '{}')
                    this.props.addFilter({
                        optionsColecao: mountFilter(value.filtros.colecoes),
                    });

                this.props.setOcupacaoCapacidadeNos(value.ocupacaoNos);
            }
        } catch (_) {
            this.props.showError('Erro ao buscar dados!');
        }

        if (showLoading) this.props.hideLoading();

        // this._showProgressLoadingSaveErp();
    };

    _getDadosFiltros = () => {
        this.props.showLoading();
        Promise.all([this.updateFiltros(), this._getDados(null, false)]).then(() => {
            this.props.hideLoading();
        });
    };

    _toggleLarge = (e, material, data, hash, estacao, colecao, cor, conjuntoComp) => {
        if (this.state.large) {
            this.setState({
                modalData: [],
                large: !this.state.large,
                editingMaterials: [],
            });

            let paramsArray = [{ material: material, estacao: this.estacao, colecao: this.colecao, cor: this.cor }];

            if (this.conjuntoComp) {
                this.conjuntoComp.forEach((e) => {
                    let dados = this.data.filter(
                        (x) => x.material === e.material && x.estacao === this.estacao && x.colecao === this.colecao
                    );
                    paramsArray = paramsArray.concat(
                        dados.map((x) => ({ material: e.material, estacao: this.estacao, colecao: this.colecao, cor: x.cor }))
                    );
                });
            }

            this._getDados(paramsArray);
            this.filtroDataModalDetalhes = {};
            return;
        }
        const indexBloqued = this.hashes[hash];

        var skuReadonly = false;
        if (typeof indexBloqued === 'number') {
            const line = this.data.slice(2)[indexBloqued];
            skuReadonly = line && (line.readonly || !line.checked);
        }

        this.colecao = colecao;
        this.estacao = estacao;
        this.cor = cor;
        this.conjuntoComp = conjuntoComp;

        this.filtroDataModalDetalhes = {
            dataAtu: this.filtroData.dataAtu,
            dataFim: this.filtroData.dataFim,
            dataReq: data,
            material,
            estacao,
            colecao,
        };

        this.setState({ large: !this.state.large, skuReadonly });
    };

    _onBlur = ({ name, e, i }) => {
        const data = this.data[i];
        const { isLoading } = this.props;

        if (isLoading || !data || !this.lastActionOnChange || this.aplicadoEmLote) return;
        this.lastActionOnChange = false;
        this.aplicadoEmLote = false;

        const defaultData = {
            material: data.material,
            data: data.data,
            estacao: data.estacao,
            colecao: data.colecao,
            cor: data.cor,
            naoPrograma: data.naoPrograma,
            tabelas: this.getTabelasVersao(),
        };
        switch (name) {
            case 'qtdProgramada':
                this._atualizaQuantidade({ ...defaultData, conjuntoComp: data.conjuntoComp, quantidade: data.qtdProgramada });
                break;
            case 'percAnt':
                this._atualizaQuantidade({ ...defaultData, percentual: data[name] });
                break;
            case 'percAntVendaFutura':
                this._atualizaQuantidade({ ...defaultData, percentual: data[name] });
                break;
            case 'percEstoqueSeg':
                this._atualizaPercEstSeg({ ...defaultData, percentual: data[name] });
                break;
            default:
                return;
        }
    };

    _constroiObjeto = (row) => ({
        qtdProgramada: {
            material: row.material,
            conjuntoComp: row.conjuntoComp,
            data: row.data,
            estacao: row.estacao,
            colecao: row.colecao,
            quantidade: row.qtdProgramada,
            cor: row.cor,
            permanencia: row.permanencia,
        },
        qtdNecMulti: {
            material: row.material,
            conjuntoComp: row.conjuntoComp,
            data: row.data,
            estacao: row.estacao,
            colecao: row.colecao,
            cor: row.cor,
            qtdNecessidade: true,
            permanencia: row.permanencia,
        },
        percAnt: {
            material: row.material,
            data: row.data,
            estacao: row.estacao,
            colecao: row.colecao,
            percentual: row.percAnt,
            cor: row.cor,
            permanencia: row.permanencia,
            vendaFutura: row.vendaFutura,
        },
        percAntVendaFutura: {
            material: row.material,
            data: row.data,
            estacao: row.estacao,
            colecao: row.colecao,
            percentual: row.percAntVendaFutura,
            cor: row.cor,
            permanencia: row.permanencia,
            vendaFutura: true,
        },
        percEstoqueSeg: {
            material: row.material,
            data: row.data,
            estacao: row.estacao,
            colecao: row.colecao,
            percentual: row.percEstoqueSeg,
            cor: row.cor,
            permanencia: row.permanencia,
        },
    });

    _onPaste = ({ name, e, i }) => {
        const rows = e.clipboardData.getData('text').split('\n');
        const quantidadeDeInputsDiponiveis = this.data.length - i;

        if (rows.length - 1 > quantidadeDeInputsDiponiveis) rows.slice(0, quantidadeDeInputsDiponiveis);

        var items = [];
        const data = [...this.data];

        for (const row in rows) {
            const iRow = parseInt(row) + i;

            if (!data[iRow].checked) continue;

            const value = parseFloat(rows[row]);
            if (!/^\d+$/.test(value)) continue;
            data[iRow][name] = value;

            const lineUpdated = this._constroiObjeto(data[iRow])[name];

            if (lineUpdated.conjuntoComp) {
                for (let index = 0; index < lineUpdated.conjuntoComp.length; index++) {
                    const e = lineUpdated.conjuntoComp[index];
                    let dados = this.data.filter(
                        (x) => x.material === e.material && x.estacao === lineUpdated.estacao && x.colecao === lineUpdated.colecao
                    );
                    items = items.concat(
                        dados.map((x) => ({ material: e.material, estacao: lineUpdated.estacao, colecao: lineUpdated.colecao, cor: x.cor }))
                    );
                }
            }

            items.push(lineUpdated);
        }

        this.aplicadoEmLote = true;

        items = { materiais: items, tabelas: this.getTabelasVersao() };

        const callback = {
            percEstoqueSeg: () => atualizaPercEstSegLote(items),
            percAnt: () => setLoteMinimo(items),
            qtdProgramada: () => setLoteMinimo(items),
        };

        callback[name]().then((id) =>
            this.props.showProgressLoading({
                url: url(id),
                interval: 2000,
                onClose: (_) => {
                    this._getDados(items);
                },
                onFailure: (e) => {
                    this.props.showError(e);
                },
            })
        );
    };

    handleAuxClick = (event, menuNome) => {
        document.oncontextmenu = () => false;
        this.setState({ anchorEl: event.currentTarget, menuValor: event.target.value, menuNome });
        setTimeout(() => (document.oncontextmenu = () => true), 500);
    };

    handleAplicarParaTodos = async () => {
        this.props.showLoading();
        const { menuNome, menuValor } = this.state;

        let qtdPrevisao = undefined;
        let guardar = undefined;
        let multiplo = undefined;

        switch (menuNome) {
            case 'qtdPrevisao':
                qtdPrevisao = menuValor;
                break;
            case 'guardar':
                guardar = menuValor;
                break;
            case 'multiplo':
                multiplo = menuValor;
                break;
            default:
        }

        let dataPost = {
            versao: this.getTabelasVersao(),
            materiais: this.data.map((m) => ({
                material: m.material,
                data: m.data,
                estacao: m.estacao,
                colecao: m.colecao,
            })),
            qtdPrevisao,
            guardar,
            multiplo,
        };

        const processing = await alterarDados(dataPost);
        if (processing) {
            this.props.hideLoading();
            this.props.showProgressLoading({
                url: url(processing),
                interval: 5000,
                onClose: (_) => {
                    this.handleCloseMenu();
                    this._getDados();
                },
                onFailure: (e) => {
                    this.props.showError('Erro ao atualizar valor!');
                },
            });
            return;
        }
    };

    handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    };

    _onKeyPress = ({ name, e, i }) => {
        const { isLoading } = this.props;

        if (isLoading || e.key !== 'Enter' || !this.lastActionOnChange) return;

        this.lastActionOnChange = false;
        let data = this.data[i];

        switch (name) {
            case 'qtdProgramada':
                if (!data) {
                    return;
                }
                this._atualizaQuantidade({
                    material: data.material,
                    conjuntoComp: data.conjuntoComp,
                    data: data.data,
                    estacao: data.estacao,
                    colecao: data.colecao,
                    quantidade: data.qtdProgramada,
                    cor: data.cor,
                    naoPrograma: data.naoPrograma,
                    tabelas: this.getTabelasVersao(),
                });
                break;
            case 'percAnt':
                if (!data) {
                    return;
                }
                this._atualizaQuantidade({
                    material: data.material,
                    data: data.data,
                    estacao: data.estacao,
                    colecao: data.colecao,
                    percentual: data.percAnt,
                    cor: data.cor,
                    naoPrograma: data.naoPrograma,
                    tabelas: this.getTabelasVersao(),
                });
                break;
            case 'percAntVendaFutura':
                if (!data) {
                    return;
                }
                this._atualizaQuantidade({
                    material: data.material,
                    data: data.data,
                    estacao: data.estacao,
                    colecao: data.colecao,
                    percentual: data.percAntVendaFutura,
                    cor: data.cor,
                    naoPrograma: data.naoPrograma,
                    vendaFutura: true,
                    tabelas: this.getTabelasVersao(),
                });
                break;
            case 'percEstoqueSeg':
                if (!data) {
                    return;
                }
                this._atualizaPercEstSeg({
                    material: data.material,
                    data: data.data,
                    estacao: data.estacao,
                    colecao: data.colecao,
                    percentual: data.percEstoqueSeg,
                    cor: data.cor,
                    tabelas: this.getTabelasVersao(),
                });
                break;
            case 'qtdPrevisao':
                if (!data) {
                    return;
                }
                this.updateRow(name, data);
                break;
            case 'guardar':
                if (!data) {
                    return;
                }
                this.updateRow(name, data);
                break;
            case 'multiplo':
                if (!data) {
                    return;
                }
                this.updateRow(name, data);
                break;
            default:
                return;
        }
    };

    onEnableMaterial = async ({ name, e, i }) => {
        const data = this.data;

        if (data[i].readonly || name !== 'checkbox' || this.props.loading) return;

        this.lastActionOnChange = false;
        const user = this.state.username;

        if (i === 0) {
            const anyChecked = data.slice(2).some((x) => x.checked);

            if (anyChecked) {
                return socketClient.client.compress(true).emit('desbloquear_materiais_sem_hashes', { client_id: socketClient.client.id });
            } else {
                const hashes = this.data
                    .slice(2)
                    .filter((x) => !x.checked && !x.readonly && !x.naoPrograma)
                    .map((line) => line.hash);

                return socketClient.client.compress(true).emit('bloquear_materiais', { user, client_id: socketClient.client.id, hashes });
            }
        } else {
            const params = { user, client_id: socketClient.client.id, hashes: [this.data[i].hash] };

            if (data[i].checked) {
                socketClient.client.compress(true).emit('desbloquear_materiais', params);
            } else {
                socketClient.client.compress(true).emit('bloquear_materiais', params);
            }
        }
    };

    _onChange = ({ name, e, i }) => {
        const { isLoading } = this.props;

        if (isLoading) return;

        let data = this.data;
        data[i] = this.data[i];

        this.lastActionOnChange = true;

        if (e.target.pattern === '[0-9]*') {
            e.target.value = e.target.value.replace('.', '');
        }
        const value = e.target.value;

        switch (name) {
            case 'qtdProgramada':
                if (e.target.validity.valid) data[i].qtdProgramada = value;
                break;
            case 'cdFabrica':
                data[i].cdFabrica = value;
                this._atualizaFabrica(data[i]);
                break;
            case 'percAnt':
                if (e.target.validity.valid) data[i].percAnt = value;
                break;
            case 'percAntVendaFutura':
                if (e.target.validity.valid) data[i].percAntVendaFutura = value;
                break;
            case 'percEstoqueSeg':
                if (e.target.validity.valid && value <= 100) data[i].percEstoqueSeg = value;
                break;
            case 'qtdPrevisao':
                if (e.target.validity.valid) data[i].qtdPrevisao = value;
                break;
            case 'guardar':
                if (e.target.validity.valid) data[i].guardar = value;
                break;
            case 'multiplo':
                if (e.target.validity.valid) data[i].multiplo = value;
                break;
            default:
                return;
        }

        this.data = data;
        this.gridRef.forceUpdateGrids();
    };

    updateRow = (field, row) => {
        this.props.showLoading();
        let dataPost = {
            versao: this.getTabelasVersao(),
            materiais: [
                {
                    material: row.material,
                    data: row.data,
                    estacao: row.estacao,
                    colecao: row.colecao,
                },
            ],
            qtdPrevisao: field === 'qtdPrevisao' ? row.qtdPrevisao : undefined,
            guardar: field === 'guardar' ? row.guardar : undefined,
            multiplo: field === 'multiplo' ? row.multiplo : undefined,
        };

        alterarDados(dataPost)
            .then(() => {
                let paramsArray = [
                    {
                        material: row.material,
                        data: row.data,
                        estacao: row.estacao,
                        colecao: row.colecao,
                        cor: row.cor,
                    },
                ];
                this._getDados(paramsArray);
            })
            .catch(() => {
                this.props.hideLoading();
            });
    };

    _getColumnWidth = ({ index }) => {
        const coluna = this.state.colunas[index];

        if (coluna.width) {
            return coluna.width;
        }
        return 60;
    };

    _getDatum = (index) => {
        return this.data[index];
    };

    _getRowClassName = (row, cor) => {
        return clsx(row < 2 ? 'headerCell' : 'rowCell', !cor ? 'evenRow' : 'oddRow');
    };

    _noContentRenderer = () => {
        return <div className={'noCells'}></div>;
    };

    _getMaterialData = ({ material, estacao, colecao, pv, rowIndex }) => {
        const key = material + colecao + estacao;
        if (this.keys[key] === pv) return true;

        this.ultimoMaterial = material;
        this.ultimaEstacao = estacao;
        this.ultimaColecao = colecao;

        return false;
    };

    toggleTooltip(i) {
        const newArray = this.state.tooltipOpen.map((element, index) => {
            return index === i ? !element : false;
        });
        this.setState({
            tooltipOpen: newArray,
        });
        this.gridRef.forceUpdateGrids();
    }

    _renderBodyCell = ({ columnIndex, key, rowIndex, style, isVisible }) => {
        const datum = this._getDatum(rowIndex);
        const rowClass = this._getRowClassName(rowIndex, datum ? datum.cor : false);
        const valueObject = this.state.colunas[columnIndex];
        let content;

        if (rowIndex === 0) {
            //header
            if (valueObject.dataKey === 'checkbox' && datum) {
                const editable = datum.readonly || datum.naoPrograma;
                content = valueObject.cell(rowIndex, !editable, datum.checked ? datum.checked : false, (e) =>
                    this.onEnableMaterial({
                        name: valueObject.dataKey,
                        e,
                        i: rowIndex,
                    })
                );
            } else {
                const breakLines = (valueObject.label || '').split('\n');
                content = breakLines.map((x) => (
                    <span key={x}>
                        {x}
                        <br />
                    </span>
                ));
            }
        } else if (rowIndex === 1) {
            if (valueObject.sum) {
                if (valueObject.percCoberturaEstoque) {
                    content = valueObject.percCoberturaEstoque(this.data).toLocaleString('pt-BR', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });
                } else {
                    content = valueObject.sum(this.data, valueObject).toLocaleString('pt-BR', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });
                }
            } else content = '';
        } else if (valueObject.cell) {
            switch (valueObject.dataKey) {
                case 'checkbox':
                    const editable = datum.readonly || datum.naoPrograma;
                    content = valueObject.cell(rowIndex, !editable, datum.checked ? datum.checked : false, (e) =>
                        this.onEnableMaterial({
                            name: valueObject.dataKey,
                            e,
                            i: rowIndex,
                        })
                    );
                    break;
                case 'cdFabrica':
                    content = valueObject.cell(
                        datum.listaTecnica.filter((x) => x.no !== undefined && x.no !== ''),
                        datum.checked,
                        (e) =>
                            this._onChange({
                                name: valueObject.dataKey,
                                i: rowIndex,
                                e,
                            }),
                        datum.cdFabrica
                    );
                    break;
                case 'coberturaEstoque':
                    content = (datum[valueObject.dataKey] < 0 ? 0 : datum[valueObject.dataKey])?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });
                    break;
                case 'tempo':
                    content = datum[valueObject.dataKey]?.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
                    break;
                case 'totalMinutos':
                    content = datum.totalMinutos?.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });
                    break;
                case 'qtdProgramada':
                    content = valueObject.cell(
                        datum[valueObject.dataKey]?.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                        !datum.checked ||
                            (datum.conjunto && datum.conjunto === 'N') ||
                            (datum.conjuntoFilhoTipo && datum.conjuntoFilhoTipo === 'V')
                            ? false
                            : true,
                        (e) => this._onChange({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onKeyPress({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onBlur({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onPaste({ name: valueObject.dataKey, i: rowIndex, e })
                    );
                    // if (!style.alignItems) style.alignItems = 'baseline';
                    break;
                case 'percAnt':
                    content = valueObject.cell(
                        datum[valueObject.dataKey],
                        !datum.checked ||
                            (datum.conjunto && datum.conjunto === 'N') ||
                            (datum.conjuntoFilhoTipo && datum.conjuntoFilhoTipo === 'V')
                            ? false
                            : true,
                        (e) => this._onChange({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onKeyPress({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onBlur({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onPaste({ name: valueObject.dataKey, i: rowIndex, e })
                    );
                    break;
                case 'percAntVendaFutura':
                    content = valueObject.cell(
                        datum[valueObject.dataKey],
                        !datum.checked ||
                            (datum.conjunto && datum.conjunto === 'N') ||
                            (datum.conjuntoFilhoTipo && datum.conjuntoFilhoTipo === 'V')
                            ? false
                            : true,
                        (e) => this._onChange({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onKeyPress({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onBlur({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onPaste({ name: valueObject.dataKey, i: rowIndex, e })
                    );
                    break;
                case 'percEstoqueSeg':
                    content = valueObject.cell(
                        datum[valueObject.dataKey],
                        !datum.checked ||
                            (datum.conjunto && datum.conjunto === 'N') ||
                            (datum.conjuntoFilhoTipo && datum.conjuntoFilhoTipo === 'V')
                            ? false
                            : true,
                        (e) => this._onChange({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onKeyPress({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onBlur({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onPaste({ name: valueObject.dataKey, i: rowIndex, e })
                    );
                    break;
                case 'alteradoManual':
                    content = valueObject.cell(datum[valueObject.dataKey]);
                    break;
                case 'qtdPrevisao':
                case 'guardar':
                case 'multiplo':
                    content = valueObject.cell(
                        datum[valueObject.dataKey]?.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                        datum.checked,
                        (e) => this._onChange({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onKeyPress({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onBlur({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this._onPaste({ name: valueObject.dataKey, i: rowIndex, e }),
                        (e) => this.handleAuxClick(e, valueObject.dataKey)
                    );
                    break;
                case 'naoPrograma':
                    content = valueObject.cell(rowIndex, datum['naoPrograma']);
                    break;
                // case 'aplicouMI':
                //     content = valueObject.cell(rowIndex, datum['aplicouMI']);
                //     break;
                default:
                    content = valueObject.cell(datum[valueObject.dataKey], (e) =>
                        this._onChange({ name: valueObject.dataKey, i: rowIndex, e })
                    );
            }
        } else {
            const shouldBeEmptyValue = !this._getMaterialData({
                ...datum,
                rowIndex,
            });
            const value =
                typeof datum[valueObject.dataKey] === 'number'
                    ? datum[valueObject.dataKey] &&
                      datum[valueObject.dataKey].toLocaleString('pt-BR', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                      })
                    : datum[valueObject.dataKey];

            switch (valueObject.dataKey) {
                case 'material':
                case 'estacao':
                case 'colecao':
                case 'descricao':
                    content = shouldBeEmptyValue ? '' : value;
                    break;
                case 'data':
                    content = new Date(value + 'T00:00:00').toLocaleDateString('pt-BR');
                    break;
                case 'tempoTotalPreparacao':
                    content = value; // Math.round(value).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                    break;
                default:
                    content = value;
                    break;
            }
        }

        const classNames = clsx(rowClass, 'cell', {
            centeredCell: columnIndex > 2,
        });

        const mostraTooltip = rowIndex === 0 && valueObject?.descricao !== undefined;

        const iRow = rowIndex - 2;
        const iCol = columnIndex;
        const id = `inicio-row${iRow}-col${iCol}`;

        return (
            <div
                {...(rowIndex > 1 && {
                    onMouseUp: (e) => this.selectionTable.onMouseUp(iRow, iCol),
                    onMouseDown: (e) => this.selectionTable.onMouseDown(e, iRow, iCol),
                    onMouseEnter: (e) => this.selectionTable.onMouseEnter(iRow, iCol),
                    onKeyDown: (e) =>
                        this.selectionTable.onKeyDown(e, iRow, iCol, this.data.length, this.state.colunas.length, this.scroll),
                })}
                tabIndex='0'
                className={classNames}
                key={key}
                id={rowIndex === 0 ? 'header' + columnIndex : id}
                style={style}
                onDoubleClick={
                    rowIndex > 1 && columnIndex > 0
                        ? (e) =>
                              this._toggleLarge(
                                  e,
                                  datum.material,
                                  datum.data,
                                  datum.hash,
                                  datum.estacao,
                                  datum.colecao,
                                  datum.cor,
                                  datum.conjuntoComp ? datum.conjuntoComp : []
                              )
                        : () => {}
                }
                onClick={mostraTooltip === true ? () => this.toggleTooltip(columnIndex) : () => {}}
            >
                {content}
                {mostraTooltip === true ? (
                    <Tooltip placement='top' isOpen={this.state.tooltipOpen[columnIndex]} target={'header' + columnIndex}>
                        {valueObject?.descricao}
                    </Tooltip>
                ) : (
                    ''
                )}
            </div>
        );
    };

    _criarNovaVersao = async () => {
        if ((await this.validaProcessoSalvarSimulacao()) === false) return;
        this.setState({ openModalVersao: true }, this.props.hideLoading);
    };

    _onCloseModalVersao = () => this.setState({ openModalVersao: false }, this.props.hideLoading);

    _handleCriarVersao = async (data) => {
        this.props.showLoading();
        await gerarNovaVersao(data);
        this.props.showSuccess('Nova versão gerado com sucesso!');
        this.props.hideLoading();
    };

    _handleSaveEstoqueFinal = async (versoes) => {
        this._onCloseModalEstoqueFinal();
        let materiais = Array.from(
            new Set(
                this.data
                    .slice(2)
                    .filter(this._filterMaterialParaAntecipar)
                    .map((x) => x.material)
            )
        );
        const processing = await aplicarEstoqueFinalFechamento({ materiais, values: versoes });
        if (processing) {
            this.props.showProgressLoading({
                url: url(processing),
                interval: 5000,
                onClose: (_) => {
                    let message = processing.origin + ' finalizado!';
                    this.props.showSuccess(message);
                    this.loadScreenData();
                },
                onFailure: (e) => {
                    this.props.showError('Ocorreu um erro. Aperte F5');
                    this.loadScreenData();
                },
            });
        }
    };

    _handleSaveJustificativa = async (items, justificativa) => {
        this._onCloseModalJustificativa();

        const processing = await aplicarJustificativa({ items, justificativa, tabelas: this.getTabelasVersao() });
        if (processing) {
            this.props.showProgressLoading({
                url: url(processing),
                interval: 5000,
                onClose: (_) => {
                    let message = 'Aplicar justificativa finalizado!';
                    this.props.showSuccess(message);
                    this.loadScreenData();
                },
                onFailure: (e) => {
                    this.props.showError('Ocorreu um erro. Aperte F5');
                    this.loadScreenData();
                },
            });
        }
    };

    _handleRemoveJustificativa = async () => {
        const items = this.data.slice(2).filter((material) => material.checked && material.justificativaNP);

        await removerJustificativa({ items, tabelas: this.getTabelasVersao() })
            .then((res) => {
                let message = 'Justificativas removidas!';
                this.props.showSuccess(message);
                this.loadScreenData();
            })
            .catch((err) => {
                this.props.showError('Ocorreu um erro. Aperte F5');
                this.loadScreenData();
            });
    };

    _handleSaveConjuntos = async (items, conjunto) => {
        this._onCloseModalConjuntos();
        let processing = null;

        if (conjunto === '1') {
            processing = await aplicarConjunto({ materiais: items, qtdEscolha: conjunto, tabelas: this.getTabelasVersao() });
        } else if (conjunto === '2') {
            processing = await aplicarConjuntoParaBaixo({ materiais: items, qtdEscolha: conjunto, tabelas: this.getTabelasVersao() });
        }

        if (processing) {
            this.props.hideLoading();
            this.props.showProgressLoading({
                url: url(processing),
                interval: 5000,
                onClose: (_) => {
                    let message = 'Conjuntos concluido!';
                    this.props.showSuccess(message);
                    this.loadScreenData();
                },
                onFailure: (e) => {
                    this.props.showError('Ocorreu um erro. Aperte F5');
                    this.loadScreenData();
                },
            });
        }
    };
}

Planejamento.caracteristicaMapping = {
    '0000000140': 'optionsCategoriaProduto',
    '0000000141': 'optionsDestinoConfeccao',
    '0000000145': 'optionsLinhaProduto',
    '0000000175': 'optionsMarca',
    '0000000349': 'options?',
    '0000000350': 'options?',
    '0000000816': 'optionsPermanencia',
    '0000000820': 'options?',
    '0000000922': 'options?',
    '0000000924': 'options?',
};

const mapStateToProps = (store) => ({
    planejamentoFilter: store.clickState.planejamentoFilter,
    selectCapacidadeOrcada: store.capacidadeState.selectCapacidadeOrcada,
    capacidadeFilterSelected: store.capacidadeState.capacidadeFilterSelected,
    recursosCriticosFilterSelected: store.capacidadeState.recursosCriticosFilterSelected,
    isLoading: store.loadingState.loading,
    colunas: store.filterColunasPlanejamento.colunas,
    versaoSelecionada: store.versaoState.versao,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            addFilter,
            setCapacidadeOptions,
            setOcupacaoCapacidadeNos,
            setOcupacaoCapacidadeRecursosCriticos,
            setCapacidadeRecursosCriticos,
            showSuccess,
            showError,
            showLoading,
            hideLoading,
            showWarning,
            hideProgressLoading,
            showProgressLoading,
            setCurrentDataPV,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Planejamento);
